import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@glu/theming';
import { oaoTheme } from '@ces/themes';
import { BrandingContext } from '@glu/interactive-styleguide';

const activeBranding = window.localStorage.getItem('createTheme') === 'true';

const Theme = ({ children, theme }) => {
  const { branding } = useContext(BrandingContext);

  return (
    <ThemeProvider baseTheme={oaoTheme} theme={activeBranding ? branding : theme}>
      {children}
    </ThemeProvider>
  );
};

Theme.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  theme: PropTypes.shape({}).isRequired,
};

export default Theme;
